import {h, Component} from 'preact'
import tracker from '../../components/tracker/publish'
import Analytics from '../analytics/Analytics'

var isIE11 = typeof navigator !== 'undefined' && !!navigator.userAgent.match(/Trident\/7\.0/)

export interface GAEvent {
  eventCategory: string,
  eventAction: string,
  eventLabel: unknown,
}

interface Props extends JSX.HTMLAttributes {
  tag?: string|typeof Component,
  track: unknown,
  gaEvents: GAEvent,
}

export default (props: Props) => {
  const Tag = props.tag || 'a'

  return <Tag {...{...props, tag: undefined, gaEvents: undefined, track: undefined}} onClick={(e: MouseEvent) => {
    tracker.trackEvent('userevent', props.track)
    Analytics.send(props.gaEvents.eventCategory, props.gaEvents.eventAction, props.gaEvents.eventLabel)
    if (typeof props.onClick === 'function') {
      props.onClick(e)
    } else if (props.href && isIE11 && typeof window !== 'undefined') {
       window.location.href = props.href
    }
  }}>{props.children}</Tag>
}
